import { Component, Input, OnInit } from '@angular/core';
import { ICategoryModel } from 'src/app/services/videos-and-events/models/category-model';
import { IVideo } from '../../interfaces/videosByCategory';
import { VideosAndEventsService } from 'src/app/services/videos-and-events/videos-and-events.service';
import {
  VIDEOS_AND_EVENTS_CATEGORIES,
  LIVE_TRANSMISSIONS_CATEGORY_IDS
} from 'src/app/modules/shared/enums/videos-and-events.enum';

@Component({
  selector: 'app-category-videos-swiper',
  templateUrl: './category-videos-swiper.component.html',
  styleUrl: './category-videos-swiper.component.scss'
})
export class CategoryVideosSwiperComponent implements OnInit {
  @Input() category: ICategoryModel;
  @Input() index: number;
  @Input() isLastOfPage: boolean;
  @Input() parentComponentItems: IVideo[];
  isMobile: boolean;

  isLoading = false;
  videos: IVideo[] = [];
  totalCount: number;
  currentPage = 0;
  pageSize = 12;

  constructor(private videosAndEventsService: VideosAndEventsService) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 900;
    this.loadCategoryVideosPerPage();
  }

  loadCategoryVideosPerPage(): void {
    const categoryId = String(this.category.id).trim();
    const isLiveTransmissionCategory = LIVE_TRANSMISSIONS_CATEGORY_IDS.some(
      (id) => String(id).trim() === categoryId
    );

    this.isLoading = true;
    this.videosAndEventsService
      .getVideosWithQuery({
        page: this.currentPage + 1,
        pageSize: this.pageSize,
        categoryId: this.category.id,
        ...(isLiveTransmissionCategory && {
          orderBy: 'data DESC'
        })
      })
      .result$.subscribe({
        next: (response) => {
          const data = response?.data;
          if (!data) return;

          const mapped: IVideo[] = data.items.map((video) => ({
            id: video.id,
            title: video.titulo,
            subtitle: video.resumo,
            videoURL: video.conteudo,
            categoryId: video.categoria.id,
            imagem: video.imagem,
            imagemMobile: video.imagemMobile,
            data: video.data,
            statusTransmissaoValue: video.statusTransmissaoValue,
            dateTimeTransmissao: video.dateTimeTransmissao
          }));

          const videosToDisplay =
            this.parentComponentItems?.length > 0
              ? this.parentComponentItems
              : mapped;

          this.videos = isLiveTransmissionCategory
            ? this.sortLiveVideos(videosToDisplay)
            : videosToDisplay;

          this.pageSize = data.pageSize;
          this.totalCount = data.totalCount;

          this.isLoading = false;
        },
        error: (error) => {
          console.error('Failed to load videos', error);
          this.isLoading = false;
        }
      });
  }

  private sortLiveVideos(items: IVideo[]): IVideo[] {
    return [...items].sort((a, b) => {
      const priorityA = this.getVideoPriority(a);
      const priorityB = this.getVideoPriority(b);

      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      if (priorityA === 2) {
        return this.getTransmissionTime(b) - this.getTransmissionTime(a);
      }

      return this.getTransmissionTime(a) - this.getTransmissionTime(b);
    });
  }

  private getVideoPriority(video: IVideo): number {
    const status = this.normalizeStatus(video.statusTransmissaoValue);

    if (status === 'ao_vivo') {
      return 0;
    }

    if (status === 'agendada' || status === 'em_breve') {
      return 1;
    }

    const transmissionTime = this.getTransmissionTime(video);
    return transmissionTime > Date.now() ? 1 : 2;
  }

  private normalizeStatus(status?: string | null): string | null {
    return status?.trim().toLowerCase().replace(/\s+/g, '_') ?? null;
  }

  private getTransmissionTime(video: IVideo): number {
    if (video.dateTimeTransmissao) {
      const time = new Date(video.dateTimeTransmissao).getTime();
      return Number.isNaN(time) ? 0 : time;
    }

    return video.data?.rawValue ?? 0;
  }
}
